import {
    createTheme,
    type PaletteMode,
    type Theme,
} from '@mui/material/styles';

import { components } from './components';
import { darkPalette } from './palette/dark';
import { lightPalette } from './palette/light';
import { colors } from './palette/colors';
import { shape } from './tokens/shape';
import { typography } from './tokens/typography';

export function createAppTheme(mode: PaletteMode): Theme {
    return createTheme({
        direction: 'rtl',

        palette: mode === 'dark' ? darkPalette : lightPalette,

        app: {
            status: {
                errorBackground: colors.status.error.translucentBackground,
            },
        },

        typography,

        shape,

        components,
    });
}
